{
  "MFA_SETTINGS": {
    "TITLE": "2단계 인증",
    "SUBTITLE": "TOTP 기반 인증으로 계정을 보호하십시오",
    "DESCRIPTION": "시간 기반 일회용 비밀번호(TOTP)를 사용하여 계정에 추가 보안 계층을 적용합니다",
    "STATUS_TITLE": "인증 상태",
    "STATUS_DESCRIPTION": "2단계 인증 설정 및 백업 복구 코드를 관리합니다",
    "ENABLED": "사용함",
    "DISABLED": "사용 안 함",
    "STATUS_ENABLED": "2단계 인증이 활성화되어 있습니다",
    "STATUS_ENABLED_DESC": "계정이 추가 보안 계층으로 보호되고 있습니다",
    "ENABLE_BUTTON": "2단계 인증 사용하기",
    "ENHANCE_SECURITY": "계정 보안 강화",
    "ENHANCE_SECURITY_DESC": "2단계 인증은 비밀번호 외에 인증 앱의 인증 코드를 추가로 요구하여 보안을 강화합니다.",
    "SETUP": {
      "STEP_NUMBER_1": "1",
      "STEP_NUMBER_2": "2",
      "STEP1_TITLE": "인증 앱으로 QR 코드를 스캔하십시오",
      "STEP1_DESCRIPTION": "Google Authenticator, Authy 또는 TOTP 호환 앱을 사용하십시오",
      "LOADING_QR": "로딩 중...",
      "MANUAL_ENTRY": "스캔할 수 없습니까? 코드를 수동으로 입력하십시오",
      "SECRET_KEY": "비밀 키",
      "COPY": "복사",
      "ENTER_CODE": "인증 앱에서 6자리 코드를 입력하십시오",
      "ENTER_CODE_PLACEHOLDER": "000000",
      "VERIFY_BUTTON": "확인 후 계속",
      "CANCEL": "취소",
      "ERROR_STARTING": "MFA가 활성화되지 않았습니다. 관리자에게 문의하십시오.",
      "INVALID_CODE": "잘못된 인증 코드입니다",
      "SECRET_COPIED": "비밀 키가 클립보드에 복사되었습니다",
      "SUCCESS": "2단계 인증이 성공적으로 활성화되었습니다"
    },
    "BACKUP": {
      "TITLE": "백업 코드를 저장하십시오",
      "DESCRIPTION": "이 코드를 안전하게 보관하십시오. 인증 앱에 접근할 수 없을 때 각 코드를 한 번씩 사용할 수 있습니다.",
      "IMPORTANT": "중요:",
      "IMPORTANT_NOTE": " 이 코드를 안전한 장소에 저장하십시오. 다시 확인할 수 없습니다.",
      "DOWNLOAD": "다운로드",
      "COPY_ALL": "모두 복사",
      "CONFIRM": "백업 코드를 안전한 장소에 저장했으며 다시 확인할 수 없다는 것을 이해합니다",
      "COMPLETE_SETUP": "설정 완료",
      "CODES_COPIED": "백업 코드가 클립보드에 복사되었습니다"
    },
    "MANAGEMENT": {
      "BACKUP_CODES": "백업 코드",
      "BACKUP_CODES_DESC": "기존 코드를 분실했거나 사용한 경우 새 코드를 생성하십시오",
      "REGENERATE": "백업 코드 재생성",
      "DISABLE_MFA": "2FA 비활성화",
      "DISABLE_MFA_DESC": "계정에서 2단계 인증을 제거합니다",
      "DISABLE_BUTTON": "2단계 인증 비활성화"
    },
    "DISABLE": {
      "TITLE": "2단계 인증 비활성화",
      "DESCRIPTION": "2단계 인증을 비활성화하려면 비밀번호와 인증 코드를 입력해야 합니다.",
      "PASSWORD": "비밀번호",
      "OTP_CODE": "인증 코드",
      "OTP_CODE_PLACEHOLDER": "000000",
      "BACKUP_CODE": "백업 코드",
      "BACKUP_CODE_PLACEHOLDER": "백업 코드 중 하나를 입력하십시오",
      "USE_BACKUP_CODE": "Lost access to your authenticator? Use a backup code instead",
      "USE_OTP_CODE": "Use a verification code from your authenticator app",
      "CONFIRM": "2FA 비활성화",
      "CANCEL": "취소",
      "SUCCESS": "2단계 인증이 비활성화되었습니다",
      "ERROR": "MFA 비활성화에 실패했습니다. 자격 증명을 확인해 주십시오."
    },
    "REGENERATE": {
      "TITLE": "백업 코드 재생성",
      "DESCRIPTION": "기존 백업 코드가 무효화되고 새 코드가 생성됩니다. 계속하려면 인증 코드를 입력하십시오.",
      "OTP_CODE": "인증 코드",
      "OTP_CODE_PLACEHOLDER": "000000",
      "CONFIRM": "새 코드 생성",
      "CANCEL": "취소",
      "NEW_CODES_TITLE": "새 백업 코드가 생성되었습니다",
      "NEW_CODES_DESC": "기존 백업 코드가 무효화되었습니다. 이 새 코드를 안전한 장소에 저장하십시오.",
      "CODES_IMPORTANT": "중요:",
      "CODES_IMPORTANT_NOTE": " 각 코드는 한 번만 사용할 수 있습니다. 이 창을 닫기 전에 저장하십시오.",
      "DOWNLOAD_CODES": "코드 다운로드",
      "COPY_ALL_CODES": "모든 코드 복사",
      "CODES_SAVED": "코드를 저장했습니다",
      "SUCCESS": "새 백업 코드가 생성되었습니다",
      "ERROR": "백업 코드 재생성에 실패했습니다"
    }
  },
  "MFA_VERIFICATION": {
    "TITLE": "2단계 인증",
    "DESCRIPTION": "계속하려면 인증 코드를 입력하십시오",
    "AUTHENTICATOR_APP": "인증 앱",
    "BACKUP_CODE": "백업 코드",
    "ENTER_OTP_CODE": "인증 앱에서 6자리 코드를 입력하십시오",
    "ENTER_BACKUP_CODE": "백업 코드 중 하나를 입력하십시오",
    "BACKUP_CODE_PLACEHOLDER": "000000",
    "VERIFY_BUTTON": "확인",
    "TRY_ANOTHER_METHOD": "다른 인증 방법 시도",
    "CANCEL_LOGIN": "취소하고 로그인 페이지로 돌아가기",
    "HELP_TEXT": "로그인에 문제가 있습니까?",
    "LEARN_MORE": "2FA에 대해 자세히 알아보기",
    "HELP_MODAL": {
      "TITLE": "2단계 인증 도움말",
      "AUTHENTICATOR_TITLE": "인증 앱 사용",
      "AUTHENTICATOR_DESC": "인증 앱(Google Authenticator, Authy 등)을 열고 계정에 표시된 6자리 코드를 입력하십시오.",
      "BACKUP_TITLE": "백업 코드 사용",
      "BACKUP_DESC": "인증 앱에 접근할 수 없는 경우 2FA 설정 시 저장한 백업 코드 중 하나를 사용할 수 있습니다. 각 코드는 한 번만 사용할 수 있습니다.",
      "CONTACT_TITLE": "추가 도움이 필요하십니까?",
      "CONTACT_DESC_CLOUD": "인증 앱과 백업 코드 모두에 접근할 수 없는 경우 Chatwoot 지원팀에 문의하십시오.",
      "CONTACT_DESC_SELF_HOSTED": "인증 앱과 백업 코드 모두에 접근할 수 없는 경우 관리자에게 문의하십시오."
    },
    "VERIFICATION_FAILED": "인증에 실패했습니다. 다시 시도해 주십시오."
  }
}
